import KontaktForm from "./modules/KontaktForm";
import {map as createMap, icon as createIcon, marker as createMarker} from "@smartmaps/maps";
import markerIcon from "../images/marker.svg";

document.addEventListener("DOMContentLoaded", async function () {
    if (document.querySelector('.kampagne2')) {
        new KontaktForm($('.js-kontakt-form'));

        const mapElement = document.querySelector('#map');
        const mapFormElement = document.querySelector('.map-form-inner');
        const weiterePartnerElement = document.querySelector('#weiterePartner');
        const fullResetButton = document.querySelector('#full-reset-map');

        const state = {}

        const cards = document.querySelectorAll('.pi-info');

        const icon = createIcon({
            iconUrl: markerIcon,
            iconSize: [30, 49],
            iconAnchor: [15, 49]
        });

        const map = await createMap('map', '3%2BIrM%2Buvm2M5ynFYjCcLdp8qPrX7hyWiAnAExFzUh28%3D');

        const getDataFromCard = function (card) {
            return {
                text: card.querySelector('.card-text').innerHTML,
                link: card.querySelector('.hu-link')?.href
            }
        }

        const openMapForm = function (data, marker) {
            mapFormElement.querySelector('.address').innerHTML = data.text;

            const huButton = mapFormElement.querySelector('#hu-erinnerung');
            if (data.link) {
                huButton.classList.remove('hidden');
                huButton.href = data.link;
            } else {
                huButton.classList.add('hidden');
            }
            weiterePartnerElement.classList.add('hidden');
            mapFormElement.classList.remove('hidden');
            map.setView(marker.getLatLng(), 16);
        }

        const closeMapForm = function () {
            weiterePartnerElement.classList.remove('hidden');
            mapFormElement.classList.add('hidden');
            const markers = state.cityMarkers ? state.cityMarkers : state.markers;
            map.fitBounds(markers.map(marker => marker.getLatLng()));
        }

        const createMarkerFromCard = function (card) {
            const lat = +card.dataset.lat;
            const lng = +card.dataset.lng;

            return createMarker({lat, lng}, {icon});
        }

        const resetMap = function () {
            if (state.cityMarkers) {
                state.cityMarkers.forEach(marker => marker.remove());
                state.cityMarkers = undefined;
                state.markers.forEach(marker => marker.addTo(map));
            }
        }

        const clearMap = function () {
            if (state.cityMarkers) {
                state.cityMarkers.forEach(marker => marker.remove());
                state.cityMarkers = undefined;
            }
            state.markers.forEach(marker => marker.remove());
        }

        mapFormElement.querySelector('#reset-map').addEventListener('click', closeMapForm);

        document.querySelector('#other-locations').addEventListener('submit', async event => {
            event.preventDefault();

            const data = await fetch(event.currentTarget.dataset.link, {
                method: 'POST',
                body: JSON.stringify({'city': event.currentTarget.querySelector('#city').value})
            });
            const partners = await data.json();

            if (!partners.length) return;

            clearMap();

            state.cityMarkers = partners.map(partner => {
                const cardData = {
                    text: `
                        <p class="card-text">
                            <strong><span class="pb-2">${ partner.companyName }</span></strong><br>
                            ${ partner.street }<br>
                            ${ partner.zip } ${ partner.city }<br>
                            ${ partner.phone ? `Fon: <a href="tel:${ partner.phone }">${ partner.phone }</a>` : '' }<br>
                            ${ partner.email ? `Mail: <a href="mailto:${ partner.email }">${ partner.email }</a>` : '' }<br>
                            ${ partner.homepage ? `Web: <a href="${ partner.homepage }" target="_blank">${ partner.homepage }</a>` : '' }
                        </p>
                    `,
                    link: `/de/privatkunden/vorgeschriebene-fahrzeuguntersuchungen/hauptuntersuchung-hu/hu-erinnerung?buero=${ partner.buero }&ub=${ partner.ubuero }`
                };

                const marker = createMarker({ lat: partner.geoy, lng: partner.geox}, { icon })

                marker.on('click', () => {
                    openMapForm(cardData, marker);
                })

                marker.addTo(map);

                return marker;
            });

            map.fitBounds(state.cityMarkers.map(marker => marker.getLatLng()));
            fullResetButton.classList.remove('hidden');
        });

        fullResetButton.addEventListener('click', () => {
            resetMap();
            map.fitBounds(state.markers.map(marker => marker.getLatLng()));
            fullResetButton.classList.add('hidden');
        })

        state.markers = Array.from(cards).map(card => {
            const marker = createMarkerFromCard(card);
            const data = getDataFromCard(card);

            marker.on('click', () => {
                openMapForm(data, marker);
            });
            card.querySelector('.location').addEventListener('click', () => {
                resetMap();
                openMapForm(data, marker);
                mapElement.scrollIntoView();
            });

            marker.addTo(map);

            return marker;
        });

        map.fitBounds(state.markers.map(marker => marker.getLatLng()));
    }
})
